/*
创建者 李伟(2018.5.31)
右侧商品
*/
<template>
  <div class="squares" style="text-align:left;">
    <ul class="list_pic clearfix">
      <li v-handle-hover class="item" v-for="item in data" :key="item.goodsId">
        <div class="goods-content">
          <div class="goods-pic">
            <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
              <img :src="item.thumbnail" :alt="item.name" />
            </router-link>
          </div>
          <div class="goods-info">
            <div class="goods-pic-scroll-show">
              <div class="ul">
                <img :src="item.thumbnail" height="28" width="28" border="0">
              </div>
            </div>
            <div class="goods-name">
              <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
                <span v-html="item.name"></span>
              </router-link>
              <img v-if="item.storeId==1" src="//static.kxymall.com/images/gdzy.png" width="44" height="16" style="width:44px;height:16px;border:0;vertical-align:middle;position:relative;top:-2px;margin-right:3px;" title="开心自营，品质保障" />
              <label v-if="item.goodsTransfeeCharge==1" style="background-color:red;color:white">包邮</label>
            </div>
            <div class="goods-price" v-if="goodsType==='batch'">
              <span style="float: left;">批发价：</span>
              <em class="sale-price" :title="'原价：¥'+item.mktprice">¥{{item.price}}</em>
              <span style="float: left;margin-left:20px;">会员价：</span>
              <span style="text-decoration:line-through;">¥{{item.batchPrice}}</span>
            </div>
            <div class="goods-price" v-else>
              <em class="sale-price" :title="'原价：¥'+item.mktprice">¥{{item.price}}</em>
            </div>
            <div class="sell-stat">
              <ul>
                <li>
                  <a href="javascript:void(0)" onclick="return false;" class="status">{{item.buyNum}}</a>
                  <p>商品销量</p>
                </li>
                <li>
                  <a href="javascript:void(0)" onclick="return false;">{{item.commentNum}}</a>
                  <p>用户评论</p>
                </li>
              </ul>
            </div>
            <div class="store">
              <router-link :to="{path:'/shop',query:{store_id:item.storeId,tab:1}}" target="_blank">
                店铺：{{item.storeName}}
              </router-link>
            </div>
            <div class="add-cart" v-if="goodsType==='batch'">
              <span>起批量：{{item.batchAmount}}</span>
              <router-link :to="{path:'/goods',query:{goods_id:item.oriGoodsId}}" target="_blank">点击查看原商品
              </router-link>
            </div>
            <div class="add-cart" v-else>
              <a @click.stop.prevent="cAddCart(item)" class="add_cart">
                加入购物车
              </a>
              <a @click.stop.prevent="buynow(item.goodsId, item.storeId,item)" class="buynow">
                立即购买
              </a>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { cartBuy } from 'api/goodsCart'
import { mapGetters } from "vuex"
export default {
  props: ["data"],
  directives: {
    handleHover(el) {
      $(el).hover(
        function () {
          $(el).find(".goods-info").animate({ "top": "150px" }, 400, "swing");
        }, function () {
          $(el).find(".goods-info").stop(true, false).animate({ "top": "230px" }, 400, "swing");
        });
    }
  },
  computed: {
    ...mapGetters([
      "sid"
    ]),
    // 计算是否已登陆
    isLogin() {
      return this.sid && this.sid.length > 0 ? true : false;
    },
    goodsType() {
      return this.$route.query.goodsType
    }
  },
  methods: {
    buynow(goodsId, storeId, item) {
      if (this.isLogin) {
        let minNum = item.minBuyNum > 1 ? item.minBuyNum : 1
        cartBuy({
          buyFlag: 1,
          goodsId: goodsId,
          goodsNum: minNum
        }).then(res => {
          if (res.resCode === 1) {
            this.$router.push({
              path: '/checkout',
              query: {
                storeId: storeId,
                num: minNum,
                goodsId: goodsId,
                coupon: res.data.coupon,
                chainGoodsProfit: res.data.chainGoodsProfit,
                checkAtTheShoppingPv: res.data.checkAtTheShoppingPv,
                couponLimit: res.data.checkAtTheCoupon,
                selfShoppingPv: res.data.selfShoppingPv
              }
            })
          } else {
            this.$Message.info(res.resDesc);
          }
        })
      } else {
        this.$Modal.confirm({
          title: '温馨提示',
          content: '<p>您当前是游客身份，游客身份不能购买商品！</p>',
          okText: "马上登录",
          onOk: () => {
            document.cookie = "loginReferrer=" + escape(location.href.split(location.host)[1]) + "; path=/";
            this.$router.push('/login');
          },
          cancelText: "取消",
          onCancel: () => {
          }
        });
      }
    },
    // 添加购物车
    cAddCart(item) {
      if (this.isLogin) {
        this.$store.dispatch('addCart', {
          id: item.goodsId,
          num: item.minBuyNum > 1 ? item.minBuyNum : 1
        }).then(res => {
          if (res.resCode === 1) {
            this.$Message.info('成功加入购物车');
          } else {
            this.$Message.info(res.resDesc);
          }
        })
      } else {
        this.$Modal.confirm({
          title: '温馨提示',
          content: '<p>您当前是游客身份，游客身份不能加入购物车！</p>',
          okText: "马上登录",
          onOk: () => {
            document.cookie = "loginReferrer=" + escape(location.href.split(location.host)[1]) + "; path=/";
            this.$router.push('/login');
          },
          cancelText: "取消",
          onCancel: () => {
          }
        });
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// module-right-goods.vue?7850d960